import { ALL_SOCKET_EVENTS } from './socketEvents';

// Singleton to manage allowed events and a pause/resume set for notifications
const pausedEvents = new Set();
const disabledEvents = new Set();

export function isValidSocketEvent(eventName) {
  if (!eventName) return false;
  return ALL_SOCKET_EVENTS.includes(eventName);
}

export function pauseEvent(eventName) {
  if (!isValidSocketEvent(eventName)) return false;
  pausedEvents.add(eventName);
  return true;
}

export function resumeEvent(eventName) {
  if (!isValidSocketEvent(eventName)) return false;
  pausedEvents.delete(eventName);
  return true;
}

export function disableEvent(eventName) {
  if (!isValidSocketEvent(eventName)) return false;
  disabledEvents.add(eventName);
  return true;
}

export function enableEvent(eventName) {
  if (!isValidSocketEvent(eventName)) return false;
  disabledEvents.delete(eventName);
  return true;
}

export function isEventEnabled(eventName) {
  if (!isValidSocketEvent(eventName)) return false;
  return !disabledEvents.has(eventName);
}

export function isEventPaused(eventName) {
  if (!isValidSocketEvent(eventName)) return false;
  return pausedEvents.has(eventName);
}

const socketManager = {
  isValidSocketEvent,
  pauseEvent,
  resumeEvent,
  isEventPaused,
  disableEvent,
  enableEvent,
  isEventEnabled,
};

export default socketManager;
